module.exports = __webpack_public_path__ + "static/media/trash.fbaaa767.svg";